export const getSupportEmailAddress = () => {
  switch (window.top.__INITIAL_STATE__.user.defaultCountry) {
    case 'NL':
      return 'support.focus@teamleader.nl';
    case 'BE':
      return 'support.focus@teamleader.be';
    case 'CH':
    case 'AT':
    case 'DE':
      return 'support.focus@teamleader.de';
    case 'ES':
      return 'support.focus@teamleader.es';
    case 'FR':
      return 'support.focus@teamleader.fr';
    case 'IT':
      return 'support.focus@teamleadercrm.it';
    case 'GB':
      return 'support@teamleader.co.uk';
  }

  return 'support.focus@teamleader.eu';
};

const TeamleaderContactService = {
  getSupportEmailAddress,
};

export default TeamleaderContactService;
